import { createContext } from 'react'
import IUserContext from '../types/UserContext'

export default createContext<IUserContext>({
  user: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setUser: () => {},
})
